/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionended1Inputs */

const en_actionended1 = /** @type {(inputs: Actionended1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action ended`)
};

const de_actionended1 = /** @type {(inputs: Actionended1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktion beendet`)
};

/**
* | output |
* | --- |
* | "Action ended" |
*
* @param {Actionended1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionended1 = /** @type {((inputs?: Actionended1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionended1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionended1(inputs)
	return de_actionended1(inputs)
});
export { actionended1 as "actionEnded" }